import actions from './actions'

// list helper 
import ListHelper from '../../utils/listHelper'

const defaultObject = {
    avatar: '',
    desc: '',
    hashtag: [],
    name: '',
    status: '',
    user_id: [],
    object_id: 0,
    education: ''
}

const initState = {
    objects: [],
    currentObject: {},
    textSearch: "",
    lastTextSearch: "",

    total: 0,
    pageSize: 8,
    pageIndex: 1,

    // cache
    _status: 1,
    avatar_file: null,

    // modal
    modalInfoObjectState: false,
    modalConfirmDeleteObjectState: false,
    currentListObject: [],

    // selected object
    selected_object: [],
    suggestionData : [],

}

// compare function
const compareSameObject = (a, b) => {
    return a.object_id === b.object_id
}

const _handleUpdateListObjects = (state, objects) => {
    let newObjects = []
    let selected_object = state.selected_object

    for (let index = 0; index < objects.length; index++) {
        let object = {
            ...objects[index],
            ...{
                isSelect: ListHelper.checkItemInList(selected_object, objects[index], compareSameObject)
            }
        }
        newObjects.push(object)
    }

    return {
        ...state,
        ...{
            objects: newObjects,
            avatar_file: null
        }
    }
}

const _handleUpdateSelectObjectState = (state, oid, selectState) => {
    let newObjects = []
    const objects = state.objects
    let selected_object = state.selected_object

    for (let index = 0; index < objects.length; index++) {
        let isSelect = objects[index].isSelect
        let object = objects[index]
        if (objects[index].object_id === oid) {
            isSelect = selectState

            object = {
                ...objects[index],
                ...{
                    isSelect
                }
            }

            // update select list
            if (selectState === true) {
                if (!ListHelper.checkItemInList(selected_object, object, compareSameObject))
                    selected_object = ListHelper.insertItemToList(selected_object, object)
            }
            else 
            {
                if (ListHelper.checkItemInList(selected_object, object, compareSameObject))
                    selected_object = ListHelper.deleteItemInList(selected_object, a => compareSameObject(a, object))
            }

        }


        newObjects.push(object)
    }

    return {
        ...state,
        ...{
            objects: newObjects, 
            selected_object
        }
    }
}

const _handleUpdateSelectedObject = (state, selected_object) => {
    let newObjects = []
    let objects = state.objects

    for (let index = 0; index < objects.length; index++) {
        let object = {
            ...objects[index],
            ...{
                isSelect: ListHelper.checkItemInList(selected_object, objects[index], compareSameObject)
            }
        }
        newObjects.push(object)
    }

    return {
        ...state,
        ...{
            objects: newObjects,
            selected_object,
            avatar_file: null
        }
    }
}

const reducer = (state = initState, action) => {
    console.log("Actions : ", action)
    switch (action.type) {
        case actions.type.GET_SUGGESTION_DATA_DONE:
            return{
                ...state,
                ...{
                    suggestionData: action.payload.data
                }
            }
        case actions.type.LOAD_LIST_OBJECTS:
            return state

        case actions.type.LOAD_LIST_OBJECTS_SUCCESS:
            return _handleUpdateListObjects(state, action.payload.objects)

        case actions.type.SET_DEFAULT_CURRENT_OBJECT:
            return {
                ...state,
                ...{
                    currentObject: defaultObject,
                    avatar_file: null,
                },
            }

        case actions.type.UPDATE_CURRENT_OBJECT:
            return {
                ...state,
                ...{
                    currentObject: {
                        ...state.currentObject,
                        ...action.payload.object,
                    },
                },
            }

        case actions.type.SAVE_CURRENT_OBJECT:
            return state

        case actions.type.DELETE_OBJECT:
            return state

        case actions.type.UPDATE_STATE:
            return {
                ...state,
                ...action.payload.state,
            }

        case actions.type.CHANGE_PAGE_SIZE:
            return {
                ...state,
                ...{
                    pageSize: action.payload.pageSize,
                    pageIndex: 1,
                },
            }

        case actions.type.CHANGE_CURRENT_PAGE:
            return {
                ...state,
                ...{
                    pageIndex: action.payload.pageIndex,
                },
            }

        case actions.type.SHOW_MODAL_CURRENT_OBJECT_INFO:
            return {
                ...state,
                ...{
                    modalInfoObjectState: true,
                },
            }

        case actions.type.DISMISS_MODAL_CURRENT_OBJECT_INFO:
            return {
                ...state,
                ...{
                    modalInfoObjectState: false,
                },
            }

        case actions.type.SHOW_MODAL_CONFIRM_DELETE_OBJECT:
            return {
                ...state,
                ...{
                    modalConfirmDeleteObjectState: true,
                },
            }

        case actions.type.DISMISS_MODAL_CONFIRM_DELETE_OBJECT:
            return {
                ...state,
                ...{
                    modalConfirmDeleteObjectState: false,
                },
            }

        case actions.type.UPDATE_AVATAR:
            return {
                ...state,
                ...{
                    avatar_file: action.payload.avatar,
                },
            }

        case actions.type.GET_LIST_OBJECT_QUERY_BY_ID_DONE:
            return {
                ...state,
                ...{
                    currentListObject: action.payload.data,
                },
            }

        case actions.type.UPDATE_TEXT_SEARCH:
            return {
                ...state,
                ...{
                    textSearch: action.payload.textSearch
                }
            }

        case actions.type.SEARCH_OBJECT:
            return {
                ...state,
                ...{
                    lastTextSearch: state.textSearch
                }
            } 

        case actions.type.UPDATE_SELECT_STATE_OBJECT:
            return _handleUpdateSelectObjectState(state, action.payload.oid, action.payload.selectState)

        case actions.type.UPDATE_SELECTED_OBJECT:
            return _handleUpdateSelectedObject(state, action.payload.objects) 

        default:
            return state
    }
}

export default reducer
